/**
 * Shared empty values for selectors whose slice may be absent.
 *
 * `react-redux` decides whether to re-render by comparing the selector's result **by reference**.
 * `useSelector(state => state.x?.list ?? [])` therefore returns a different array on every call, so
 * the component re-renders on **every dispatch in the app**, whether or not `x.list` changed.
 * Returning one shared constant instead makes the "absent" case reference-stable, and the populated
 * case is already stable because it comes straight from the store.
 *
 * ⚠ Deliberately NOT frozen. Freezing would surface any accidental mutation as a throw, which is
 * arguably better, but this is a performance change that must not alter behaviour — a caller that
 * quietly mutates its fallback today would start crashing. Freeze it in a separate change, with the
 * callers checked.
 */
export const EMPTY_LIST = [];

export const EMPTY_OBJECT = {};
